import React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { cn } from '@/lib/utils.ts'

const donationVariants = cva('flex items-center gap-1 text-sm leading-[100%] tracking-[0.1px]', {
  variants: {
    state: {
      no: '*:fill-red-800',
      cash: 'font-bold text-green-500 *:fill-green-500',
      digital: 'font-bold text-blue-500 *:fill-blue-500',
      textSent: 'text-black *:fill-black',
      textClicked: 'text-black *:fill-black',
    },
  },
  defaultVariants: {
    state: 'no',
  },
})

const donationIconMap = {
  no: Icons.noDonation,
  cash: Icons.cashDonation,
  digital: Icons.digitalDonation,
  textSent: Icons.textSent,
  textClicked: Icons.textClicked,
}

export interface DonationProps extends React.HtmlHTMLAttributes<HTMLDivElement>, VariantProps<typeof donationVariants> {
  value?: string
}

export const Donation = React.forwardRef<HTMLDivElement, DonationProps>(
  ({ className, state, value, ...props }, ref) => {
    const DonationIcon = donationIconMap[state || 'no']

    return (
      <div className={cn(donationVariants({ state }))} ref={ref} {...props}>
        <DonationIcon className={cn('h-4 w-4', className)} />
        <p>{value}</p>
      </div>
    )
  }
)
